var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.77,
    height: 8.944,
    viewBox: "0 0 13.77 8.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(-150 -138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M4.123,20.621h-.1a4.121,4.121,0,0,1,.1-8.241.623.623,0,1,1,0,1.246,2.875,2.875,0,0,0-2.874,2.945,2.9,2.9,0,0,0,2.8,2.8A2.875,2.875,0,0,0,7,16.5a.623.623,0,0,1,1.246,0,4.121,4.121,0,0,1-4.12,4.121",
    transform: "translate(150 126.323)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M39.569,6.354a.621.621,0,0,1-.441-.182L37.751,4.794a.623.623,0,1,1,.881-.881l.937.937L44.237.182a.623.623,0,0,1,.881.881L40.01,6.171a.621.621,0,0,1-.441.182",
    transform: "translate(114.559 138)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M165.094,69.166h-3.4a.623.623,0,1,1,0-1.246h3.4a.623.623,0,0,1,0,1.246",
    transform: "translate(-1.947 73.927)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M161.693,111.556a.623.623,0,0,1,0-1.246h1.872a.623.623,0,0,1,0,1.246",
    transform: "translate(-1.947 33.938)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsAssessment);
export default __webpack_public_path__ + "static/media/SkillsAssessment.6c0d44e783a60e92b2ef2b76bfc5ed17.svg";
export { ForwardRef as ReactComponent };